export default "__VITE_ASSET__BfUtOUqm__"